import { Component, Input } from '@angular/core';
import { ITextColumnsTileDefinition } from '../../../../interfaces/tiles/definitions/text-columns-tile-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-text-columns-tile',
  templateUrl: './text-columns-tile.component.html',
  styleUrls: ['./text-columns-tile.component.scss'],
})
export class TextColumnsTileComponent {
  @Input() tileInstance: ITextColumnsTileDefinition;
}
